import {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  RESET_CHANGE_PASSWORD_SUCCESS
} from '../../../Constants/actionTypes';

import { API_PASSWORD_CHANGE } from '../../../Constants/apiUrls';




// Helper function to handle errors
const handleErrors = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    try {
      const errorJson = JSON.parse(errorText);
      return errorJson.error || 'Unknown Error'; // Return the error message
    } catch (e) {
      return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
    }
  }
  return null; // No error
};


export const resetOnSuccessChangePassword = () => ({
  type: 'RESET_CHANGE_PASSWORD_SUCCESS'
});


export const changePassword = (oldPassword, newPassword, confirmPassword) => async (dispatch, getState) => {
  dispatch({ type: CHANGE_PASSWORD_REQUEST });

  // Validation
  if (newPassword !== confirmPassword) {
    return dispatch({ type: CHANGE_PASSWORD_FAILURE, payload: 'New password and confirm password do not match' });
  }

  if (newPassword.length < 8) {
    return dispatch({ type: CHANGE_PASSWORD_FAILURE, payload: 'New password must be at least 8 characters long' });
  }

  // Retrieve access token from the state
  const state = getState();
  const accessToken = state.auth.accessToken; // Adjust based on your state structure

  try {
    const response = await fetch(API_PASSWORD_CHANGE, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ oldPassword, newPassword, cnewPassword: confirmPassword })
    });

    const errorMessage = await handleErrors(response); // Check for errors

    if (errorMessage) {
      throw new Error(errorMessage); // Throw an error with the actual error message
    }

    
    const data = await response.json();


    dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: data });
  } catch (error) {
    let errorMessage;
    if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
      errorMessage = 'Server is currently down. Please try again later.';
    } else {
      errorMessage = error.message;
    }
    dispatch({ type: CHANGE_PASSWORD_FAILURE, payload: error.message });
  }
};
